import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import { snakeCaseToTitleCase } from '../../../../common/utils/api_utils';
import CustomLoader from '../../../common/CustomLoader';
import showAlert from '../../../../common/utils/alert';
import CommonModalComponent from '../../../common/CommonModalComponent';
import { ErrorMessage, Field, Formik, Form } from 'formik';
import ValidationRuleForm from './ValidationRuleForm';
import { createSelectOptionsForField, addRule, updateRule } from './validation-util';
import TooltipInfo from '../../../../common/docs/TooltipInfo';

export default class ValidationDetails extends Component {
  static propTypes = {
    projectId: PropTypes.string.isRequired,
    collection: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    showmodal: false,
    rules: [],
  };
  toggleModal = () => {
    this.setState({ showmodal: !this.state.showmodal, rules: [] });
  };
  addValidationRule = () => {
    const rules = addRule(this.state.rules);
    this.setState({ rules });
  };
  saveValidationRule = async (id, ruleObj) => {
    const { projectId, collection, version, actions, rule } = this.props;
    const { uuid } = collection;
    const { validationRules } = rule;
    const rules = updateRule(this.state.rules, id, ruleObj);
    this.setState({ rules });
    const ruleData = { ...ruleObj, id: validationRules.length + 1 };
    await actions.addSingleValidationRule({
      ruleData,
      validationId: rule.uuid,
      collectionUuid: uuid,
      version,
      projectId,
    });
    this.toggleModal();
  };

  handleDelete = (validationId) => {
    const { projectId, collection, version } = this.props;
    const { uuid } = collection;
    const preConfirm = () => {
      this.props.actions.deleteCollectionValidation({
        validationId,
        version,
        projectId,
        collectionUuid: uuid,
      });
    };
    showAlert("You won't be able to revert this.", preConfirm, 'Yes, delete it!');
  };

  getCollectionFieldTitle = (field) => {
    console.log('field:::', field);
    const { fields } = this.props.collection;
    if (Array.isArray(field)) {
      let fieldTitles = [];
      field.forEach((fieldName) => {
        fieldTitles.push(fields.find((e) => e.fieldName === fieldName).fieldTitle.en);
      });
      return fieldTitles;
    }
    const findField = fields.find((e) => e.fieldName === field);
    return findField ? findField.fieldTitle.en : '';
  };
  handleDeleteRules = (entry) => {
    const { rule, projectId, collection, version } = this.props;
    const { uuid } = collection;
    const preConfirm = () => {
      this.props.actions.deleteCollectionValidationRules({
        validationId: rule.uuid,
        version,
        projectId,
        collectionUuid: uuid,
        ruleId: entry.id,
      });
    };
    showAlert('Do you want to delete this rule ?', preConfirm, 'Yes, delete it!');
  };

  createFormForRule = (setFieldValue, setFieldTouched) => {
    const { rules } = this.state;
    const { collection, collections, actions, projectId } = this.props;
    let collectionFields = createSelectOptionsForField(collection.fields);
    if (rules && rules.length > 0) {
      return rules.map((rule) => (
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
          <div className="shadow-none">
            <div className="card-content">
              <div className="row mx-auto" key={rule.id}>
                <ValidationRuleForm
                  rule={rule}
                  collections={collections}
                  actions={actions}
                  projectId={projectId}
                  collection={collection}
                  setFieldValue={setFieldValue}
                  setFieldTouched={setFieldTouched}
                  fieldOptions={collectionFields}
                  fields={collection.fields}
                  removeRule={false}
                  saveValidationRule={this.saveValidationRule}
                  saveSingleRule={true}
                />
              </div>
            </div>
          </div>
        </div>
      ));
    } else {
      return '';
    }
  };

  render() {
    const { rule, showValidationDeleteLoader, collection, flag } = this.props;
    const { validationRules } = rule;
    const description = `Go to the Delete Permissions in Settings and Enable it.`;
    return (
      <Fragment>
        <div className="row">
          <div className="col-md-6 col-lg-6">
            Name: {rule.customValidationName}
            <br />
            Rules:
            <br />
          </div>
          <div className="col-md-6 col-lg-6 text-right">
            <button
              type="button"
              className="btn btn-theme-green btn-sm"
              onClick={() => {
                this.toggleModal();
                this.addValidationRule();
              }}
            >
              <i className="wb webconnect-plus"></i>&nbsp;Add Rule
            </button>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table table-grey table-bordered connector-list">
            <thead>
              <tr>
                <th>Index</th>
                <th>Name</th>
                <th>Rule</th>
                <th>Value</th>
                <th>Message</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {validationRules && validationRules.length > 0
                ? validationRules.map((e) => (
                    <tr key={e.id}>
                      <td>{e.id}</td>
                      <td> {this.getCollectionFieldTitle(e.field)}</td>
                      <td>{snakeCaseToTitleCase(e.key)}</td>
                      <td>{e.value}</td>
                      <td> {e.message}</td>
                      <td>
                        &nbsp;
                        <button
                          className="btn btn-xs btn-theme-delete"
                          onClick={() => (flag ? this.handleDeleteRules(e) : undefined)}
                          style={{ cursor: flag ? 'pointer' : 'not-allowed' }}
                          disabled={validationRules.length === 1}
                        >
                          <i className="wb webconnect-trash-solid"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                : ''}
            </tbody>
          </table>
        </div>
        <div className="col-12 text-right pb-2">
          <button
            type="button"
            className="btn btn-sm btn-theme-delete mr-1"
            onClick={() => (flag ? this.handleDelete(rule.uuid) : undefined)}
            disabled={showValidationDeleteLoader}
            style={{ cursor: flag ? 'pointer' : 'not-allowed' }}
          >
            <i className="wb webconnect-trash-regular"></i> Delete&nbsp;
            {flag ? null : (
              <TooltipInfo
                title={description}
                headerText={`Permission Disabled!`}
                showHeader={true}
                showArrow={true}
              />
            )}
            <CustomLoader loading={showValidationDeleteLoader} />
          </button>
        </div>
        <CommonModalComponent
          showModal={this.state.showmodal}
          toggleModal={this.toggleModal}
          modalHeader={'Add rule'}
          modalSize={'modal-lg'}
        >
          <Formik
            enableReinitialize={true}
            initialValues={{ customValidationName: '' }}
            onSubmit={(values, { setSubmitting, resetForm, setErrors }) => {}}
          >
            {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
              <Form className="form-horizontal">
                {this.createFormForRule(setFieldValue, setFieldTouched)}
              </Form>
            )}
          </Formik>
        </CommonModalComponent>
      </Fragment>
    );
  }
}
